import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import { Diversity1TwoTone } from "@mui/icons-material";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { Auth } from "aws-amplify";
import AWS from "aws-sdk";
import { useEffect, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Swal from "sweetalert2";
import { deleteUserFolder } from "../../utils/deleteUserFolder";
import { uploadFileViaPresignedUrl } from "../../utils/uploadFileViaPresignedUrl";

export default function SupplierQuoteComparison({ title, link }) {
  const [file, setFile] = useState(null);
  const [trainload, setTrainload] = useState(false);
  const [compareLoad, setCompareLoad] = useState(false);
  const [file1, setFile1] = useState(null);
  const [zipdone, setZipDone] = useState(false);
  const [pdfdone, setPdfDone] = useState(false);
  const [error, setError] = useState("");
  const [error1, setError1] = useState("");
  const [userquery, setUserQuery] = useState("");
  const [userquery1, setUserQuery1] = useState("");
  const [uploadStatus, setUploadStatus] = useState(false);
  const [uploadStatus1, setUploadStatus1] = useState(false);
  const [isZipUploading, setIsZipUploading] = useState(false);
  const [isPdfUploading, setIsPdfUploading] = useState(false);
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  const handleFileChange1 = (event) => {
    setFile1(event.target.files[0]);
  };
  const [transcript, setTranScript] = useState("");
  const [transcript1, setTranScript1] = useState("");
  const [displayText, setDisplayText] = useState("");
  const [displayText1, setDisplayText1] = useState("");

  const formatResponse = (response) => {
    // Splitting and replacing bold markers
    let responseArray = response.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    return newResponse;
  };

  useEffect(() => {
    if (transcript.length > 0) {
      const trimmedTranscript = formatResponse(transcript.trim());
      let index = 0;
      const intevalId = setInterval(() => {
        setDisplayText((prev) => prev + trimmedTranscript[index]);
        index++;
        if (index === trimmedTranscript.length) {
          clearInterval(intevalId);
        }
      }, 5);

      return () => clearInterval(intevalId);
    }
  }, [transcript]);

  useEffect(() => {
    if (transcript1.length > 0) {
      const trimmedTranscript = formatResponse(transcript1.trim());
      let index = 0;
      const intevalId = setInterval(() => {
        setDisplayText1((prev) => prev + trimmedTranscript[index]);
        index++;
        if (index === trimmedTranscript.length) {
          clearInterval(intevalId);
        }
      }, 5);

      return () => clearInterval(intevalId);
    }
  }, [transcript1]);

  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  const getUsername = () =>
    localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );

  const handleUpload = async () => {
    setIsZipUploading(true);
    // setPdfDone(true);
    setZipDone(true);

    try {
      const username = getUsername();
      await deleteUserFolder(username);
      await uploadFileViaPresignedUrl(file, username);
      setIsZipUploading(false);
      setZipDone(true);
      setError("Quotation uploaded successfully.");
      setUploadStatus(true);
      // setFile(null);
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        "Error while uploading file, please refresh the page and try again.",
      );
      setZipDone(false);
    }
  };

  const handleUpload1 = async () => {
    setPdfDone(true);
    setIsPdfUploading(true);

    try {
      const username = getUsername();
      //await deleteUserFolder(username);
      await uploadFileViaPresignedUrl(file1, username);
      setIsPdfUploading(false);
      setPdfDone(true);
      setError("RFQ uploaded successfully.");
      setUploadStatus1(true);
      // setFile1(null);
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        "Error while uploading file, please refresh the page and try again.",
      );
      setPdfDone(false);
    }
  };

  const handleTrain = async () => {
    if (file && pdfdone && file1 && zipdone) {
      setError("");
      setTrainload(true);
      console.log("training started");
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var traindata = JSON.stringify({
        docpath: username,
        docname1: file.name,
        docname2: file1.name,
      });
      const trainoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: traindata,
      };

      // Create the fetch requests
      const requesttrain = fetch(
        "https://p4ifndxfbl3xplturxv7emieim0udyty.lambda-url.ap-south-1.on.aws/",
        trainoption,
      );

      Promise.all([requesttrain])
        .then(async ([trainresponse]) => {
          if (!trainresponse.ok) {
            setError("Training Failed!");
            setTrainload(false);
            throw new Error("One or both requests failed");
          }
          const data1 = await trainresponse.json();
          // const data2 = await promptresponse.json();

          // Handle the data from both responses
          console.log("Response from endpoint 1:", data1);
          // console.log("Response from endpoint 2:", data2);
          if (trainresponse.ok) {
            setError("Training completed.");
            setTrainload(false);
          }
        })
        .catch((error) => {
          // Handle any errors that occurred during the requests
          console.error("Error:", error);
          setError("Training Failed!");
          setTrainload(false);
        });
    } else {
      Swal.fire({
        html: "<p>Please upload the Zip file containing PDFs.</p>",
      });
    }
  };

  const handleCompare = async () => {
    //add filename passing parameter in post request and run post request of chatbot
    setDisplayText("");
    setDisplayText1("");
    try {
      setCompareLoad(true); // Start the loading state
      // Add filename passing parameter in POST request and run POST request of chatbot
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var traindata = JSON.stringify({
        docpath: username,
        userPrompt: userquery, // add user prompt to traindata
        engineerPrompt: userquery1,
      });
      const trainoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: traindata,
      };

      // Create the fetch request
      const requesttrain = await fetch(
        "https://ulsv4e2tzmvizwjtm2q3w4y6rq0btsps.lambda-url.ap-south-1.on.aws/",
        trainoption,
      );

      // Check if the response is successful
      if (!requesttrain.ok) {
        console.error(`HTTP error! status: ${requesttrain.status}`);
        return;
      }

      let response;
      try {
        response = await requesttrain.json();
      } catch (jsonError) {
        console.error("Error parsing JSON:", jsonError);
        return;
      }

      // Inspect the full response
      console.log("Full response:", response);

      // Handle the response based on the actual structure
      if (response?.simpleResponse && response?.engineeredResponse) {
        // Note the typo in "messsage"
        setTranScript(response.simpleResponse);
        setTranScript1(response.engineeredResponse);
      } else {
        console.error("Unexpected response structure:", response);
      }

      // Log the data
      console.log("Response data:", response.body);
    } catch (error) {
      // Handle any errors
      console.error("There was an error with the fetch request:", error);
    } finally {
      setCompareLoad(false); // End the loading state
    }
  };

  const handleButtonClick = () => {
    if (file && file1) {
      handleTrain();
    } else {
      setError("Please upload both file");
    }
  };

  const handleGenerateAnswer = () => {
    if (compareLoad) return;
    if (!userquery || !userquery1) {
      setError1("Please enter your query");
      return; // Exit the function if userquery is empty
    }

    if (!file || !file1) {
      setError1("Please upload both files");
      return; // Exit the function if both files are not uploaded
    }
    setError1("");
    handleCompare();
  };

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          alt="background-img"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          alt="background-img"
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
      {genaiaccess ? (
        <div
          style={{
            flex: "0.3",
            marginBottom: "1rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            width: "80vw",
            gap: "3rem",
            margin: "auto",
          }}
          className="input-form-chatbot"
        >
          <div className="section-container">
            <h4>
              <strong>Quote upload window</strong>
            </h4>
            <hr style={{ background: "white" }}></hr>
            <div>
              <p>Upload a quotation zip file:</p>
              <div className="field">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    accept=".zip"
                    id="zip-upload"
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="zip-upload">
                    <Button
                      variant="contained"
                      component="span"
                      style={{ width: "130px", marginRight: "1rem" }}
                    >
                      Select Zip
                    </Button>
                  </label>

                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    disabled={!file}
                    onClick={handleUpload}
                    startIcon={
                      isZipUploading && (
                        <CircularProgress color="white" size={20} />
                      )
                    }
                  >
                    Upload Zip
                  </Button>
                  {uploadStatus && (
                    <FaCheckCircle
                      style={{
                        marginLeft: "1rem",
                        color: "green",
                      }}
                      size={25}
                    />
                  )}
                </div>
                <Typography variant="body1">
                  <p style={{ wordBreak: "break-all", width: "350px" }}>
                    {file && `Selected file: ${file.name}`}
                  </p>
                </Typography>
              </div>

              <p>Upload a RFQ pdf file:</p>
              <div className="field">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    accept=".pdf"
                    id="pdf-upload1"
                    type="file"
                    onChange={handleFileChange1}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="pdf-upload1">
                    <Button
                      variant="contained"
                      component="span"
                      style={{ width: "130px", marginRight: "1rem" }}
                    >
                      Select PDF
                    </Button>
                  </label>

                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    disabled={!file1}
                    onClick={handleUpload1}
                    startIcon={
                      isPdfUploading && (
                        <CircularProgress color="white" size={20} />
                      )
                    }
                  >
                    Upload PDF
                  </Button>
                  {uploadStatus1 && (
                    <FaCheckCircle
                      style={{
                        marginLeft: "1rem",
                        color: "green",
                      }}
                      size={25}
                    />
                  )}
                </div>
                <Typography variant="body1">
                  <p style={{ wordBreak: "break-all", width: "350px" }}>
                    {file1 && `Selected file: ${file1.name}`}
                  </p>
                </Typography>
              </div>

              <div style={{ display: "flex" }}>
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  style={{ color: "white" }}
                  onClick={handleButtonClick}
                  startIcon={
                    trainload && <CircularProgress color="white" size={20} />
                  }
                >
                  Train
                </Button>
              </div>

              <p>{error}</p>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
      <div
        className="input-form-chatbot"
        style={{
          flex: "0.3",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          width: "80vw",
          margin: "2rem auto",
        }}
      >
        <div className="section-container">
          <p style={{ marginBottom: "0.25rem" }}>Enter a Simple prompt</p>
          <TextareaAutosize
            id="outlined-basic"
            minRows={1}
            value={userquery}
            onChange={(e) => setUserQuery(e.target.value)}
            style={{
              border: "1px solid white",
              borderRadius: "0.5rem",
              marginBottom: "0.5rem",
              width: "100%",
              color: "white",
              backgroundColor: "transparent",
              padding: "16.5px 14px", // Adjusted padding to match TextField height
              fontSize: "16px", // Same font size as TextField
              lineHeight: "1.4375em", // Match the line height of MUI TextField
              resize: "none", // Disable manual resizing
              overflow: "hidden", // Hide scrollbar
              boxSizing: "border-box", // Ensure padding and border are included in the element's width and height
            }}
          />

          <p style={{ marginBottom: "0.25rem" }}>Enter a Engineered prompt</p>
          <TextareaAutosize
            id="outlined-basic"
            minRows={1}
            value={userquery1}
            onChange={(e) => setUserQuery1(e.target.value)}
            style={{
              border: "1px solid white",
              borderRadius: "0.5rem",
              width: "100%",
              color: "white",
              backgroundColor: "transparent",
              padding: "16.5px 14px", // Adjusted padding to match TextField height
              fontSize: "16px", // Same font size as TextField
              lineHeight: "1.4375em", // Match the line height of MUI TextField
              resize: "none", // Disable manual resizing
              overflow: "hidden", // Hide scrollbar
              boxSizing: "border-box", // Ensure padding and border are included in the element's width and height
            }}
          />
          <Button
            style={{ margin: "1rem 0" }}
            variant="contained"
            color="primary"
            onClick={handleGenerateAnswer}
            startIcon={
              compareLoad && <CircularProgress color="inherit" size={20} />
            }
          >
            Generate Answer
          </Button>
          <p>{error1}</p>
        </div>
        <br />
        <br />
        <div className="section-container">
          <h4>
            <strong>Simple Prompt Response</strong>
          </h4>
          <hr style={{ background: "white" }}></hr>
          {displayText.length > 0 ? (
            <div
              style={{
                color: "white",
                fontFamily: "sans-serif",
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
              }}
              dangerouslySetInnerHTML={{ __html: displayText }}
            ></div>
          ) : (
            "Simple Response will be displayed here"
          )}
        </div>
        <br />
        <br />
        <div className="section-container">
          <h4>
            <strong>Engineered Prompt Response</strong>
          </h4>
          <hr style={{ background: "white" }}></hr>
          {displayText1.length > 0 ? (
            <div
              style={{
                color: "white",
                fontFamily: "sans-serif",
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
              }}
              dangerouslySetInnerHTML={{ __html: displayText1 }}
            ></div>
          ) : (
            "Engineered Response will be displayed here"
          )}
        </div>
      </div>
    </div>
  );
}
